import React from 'react';
import PropTypes from 'prop-types';

import {Icon} from 'components';

import styles from './IconsProducts.module.scss';

const types = {
  '3ds Max': '3dsMax',
  Alias: 'alias',
  AutoCAD: 'autocad',
  'BIM 360': 'bim360',
  CFD: 'cfd',
  'Civil 3D': 'civil3d',
  Dynamo: 'dynamo',
  Forge: 'forge',
  'Fusion 360': 'fusion360',
  Inventor: 'inventor',
  Maya: 'maya',
  Navisworks: 'navisworks',
  PlanGrid: 'planGrid',
  Revit: 'revit',
  Shotgun: 'shotgun',
  Infraworks: 'infraworks',
};

export const IconsProducts = ({icons}) => {
  return (
    <div className={styles.wrap}>
      {icons
        ? icons
          .slice(0, 3)
          .map(item => (
            <Icon
              key={item}
              size="large"
              type={types[item]}
              className={styles.iconProduct}
            />
          ))
        : ''}
    </div>
  );
};

IconsProducts.propTypes = {
  icons: PropTypes.arrayOf(PropTypes.string).isRequired,
};
